import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App apiUrl={import.meta.env.VITE_API_URL || null} />
  </StrictMode>,
);
